// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TagsOutlinedSvg from "@ant-design/icons-svg/es/asn/TagsOutlined";
import AntdIcon from '../components/AntdIcon';

var TagsOutlined = function TagsOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: TagsOutlinedSvg
  }));
};

TagsOutlined.displayName = 'TagsOutlined';
export default React.forwardRef(TagsOutlined);